import { I18N } from '@/constants';
import en from '@/i18n/en';
import it from '@/i18n/it';
import Vue from 'vue';
import VueI18n from 'vue-i18n';

const setDefault = () => {
  if (localStorage.getItem(I18N.STORAGE_KEY)) {
    return localStorage.getItem(I18N.STORAGE_KEY);
  }
  const locale
    = navigator.languages !== undefined
      ? navigator.languages[0]
      : navigator?.language;
  if (Object.values(I18N.LOCALES).includes(locale)) {
    return locale;
  }
  return I18N.LOCALES.EN;
};

Vue.use(VueI18n);

export default new VueI18n({
  locale: setDefault(),
  fallbackLocale: I18N.LOCALES.EN,
  messages: { [I18N.LOCALES.EN]: en, [I18N.LOCALES.IT]: it },
  silentFallbackWarn: true,
});
